import * as React from "react";
import "./ReportComplexityBar.scss";
import ReportComplexity from "../model/report/ReportComplexity";

export default function reportComplexityBar(reportComplexity: ReportComplexity) {
  const easyColor = reportComplexity == ReportComplexity.EASY ? "easy-colored" : "";
  const standardColor = reportComplexity == ReportComplexity.STANDARD ? "standard-colored" : "";
  const complexColor = reportComplexity == ReportComplexity.COMPLEX ? "complex-colored" : "";
  const easyClass = ("easy " + easyColor + standardColor + complexColor).trim();
  const standardClass = ("standard " + standardColor + complexColor).trim();
  const complexClass = ("complex " + complexColor).trim();
  return (
    <>
      <div className="complexity-scale flex-center">
        <div className={easyClass}></div>
        <div className={standardClass}></div>
        <div className={complexClass}></div>
      </div>
    </>
  );
}
